import React from "react";

import styles from "./FormWarning.module.scss";

/**
 * Renders warning message
 */
export const FormWarning = (props: {
    warningTitle?: string;
    warningText?: string;
}): React.ReactNode => {
    if (!props.warningTitle || !props.warningText) {
        return null;
    }

    return (
        <div className={styles.warning}>
            <p className={styles.warningCopy}>
                <strong>{props.warningTitle}</strong>
                <br />
                {props.warningText}
            </p>
        </div>
    );
};
